import type { SerializedMeterModel } from '@enmon/commons/lib/tools';
import type { TableColumnsType } from 'antd';
import { EmptyCell } from 'components';
import { Link } from 'react-router-dom';
import { Icon } from 'components/icon';
import { commoditiesConfig } from '@/utils/commodities';
import type { Key } from 'react';
import type { SortOrder } from 'antd/es/table/interface';
import { MeterModuleTableActions } from '../components/TableActions';

export const getMeterModelTableColumnsConfig = ({
  isMagicRole,
  sortState,
}: {
  isMagicRole: boolean;
  sortState: { field: Key | null; order: SortOrder };
}): TableColumnsType<SerializedMeterModel> => [
  {
    key: 'commodity',
    title: 'Commodity',
    width: 110,
    render: (_, record) => {
      const iconString = commoditiesConfig[record.commodity]?.iconString;
      return iconString ? <Icon iconString={iconString} /> : <EmptyCell />;
    },
  },
  {
    key: 'name',
    title: 'Model',
    width: 200,
    sorter: true,
    sortOrder: sortState.field === 'name' ? sortState.order : null,
    render: (_, record) => (
      <Link replace to={{ pathname: `/reseller-data/model-library/model/${record.id}` }}>
        {record.name}
      </Link>
    ),
  },
  {
    key: 'manufacturer',
    title: 'Manufacturer',
    width: 200,
    render: (_, record) => <>{record.manufacturer?.name ?? <EmptyCell />}</>,
  },
  ...(isMagicRole
    ? ([
        {
          key: 'action',
          width: 110,
          title: 'Actions',
          fixed: 'right',
          render: (_, record) => <MeterModuleTableActions model={record} />,
        },
      ] satisfies TableColumnsType<SerializedMeterModel>)
    : []),
];
